export default "__VITE_ASSET__n$vPus80__"